
export const language = {
    general: {
      exit: "to go out",
      welcome: "Welcome",
      or: "or",
      and: "It is",
      from: "in",
      partner: "partner",
      fromAssitive: "from Assistive.",
      signin: "To enter",
      terms: "terms of use",
      policy: "Privacy Policy",
      resend: "Resend",
      needHelp: "Need help?",
      helpCenterText: "Visit our center to access additional information about installation and best usage practices.",
      helpCenter: "Help Center",
      loading: "loading",
      domain: "Domain",
      action: "Actions",
      active: "Activate",
      inactive: "Disable",
      delete: "delete",
      pagingMessage: "Showing {{param1}} The {{param2}} in {{param3}} lines",
      badges: {
        active: 'Active',
        expired: 'Expired',
        grace: 'Grace',
        trial: 'Trial'
      },
      clipboard: {
        copied: 'Copied to clipboard',
        error: 'Failed to copy'
      }
    },
    footer:{
        rights:"All rights reserved.",
        terms:"Terms of use",
        privacy:"Privacy Policy",
        partner:"Be a partner",
        help:"Help Center"
    },
    menu: {
      home: "Start",
      report: "Reports",
      perfil: "Profile",
      hidMenu: "Hide menu",
      showMenu: "View menu",
      addSite: "Add new website",
      peopleUnique: "Because people are unique...",
      activeSite:'active site',
      activeSites:'active sites'
    },
    navbar: {
        homePage: 'Home page',
        expandMenu: 'Expand side menu',
        userDropdown: {
            trialPlan: 'Free Trial',
            defaultPlan: 'Current Plan',
            profile: 'Profile',
            account: 'Account',
            logout: 'Logout'
        }
    },
    verticalMenu: {
      sites: "Websites",
      dashboard: "Dashboard",
      installation: "Installation"
    },
    form: {
      user: "User",
      password: "Password",
      login: "To enter"
    },
    home: {
      greetings: "Welcome to the system"
    },
    views: {
      login: {
        title: "Hello!",
        subtitle: "Log in to manage your digital accessibility journey.",
        email: "Your email",
        password: "Your password",
        forgotPassword: "Forgot password?",
        remember: "Keep logged in",
        newAccount: "start a free trial",
        newPlatform: "New here?",
        error: "Sorry, but something went wrong. ",
        loggedSuccessPartA: "You have successfully connected as a",
        loggedSuccessPartB: "User for Assistive. ",
        invalidLengthPass: "The password must be at least 8 characters long.",
        invalidEmail: "Enter a valid email e.g. \"email@mail.com\"",
      },
      register: {
        title: "Start your 7-day free trial now!",
        subtitle: "No need to register a credit card",
        email: "Your email",
        emailPlaceHold: "Email (required)",
        password: "Password",
        name: "What is your name?",
        namePlaceHold: "Name (required)",
        partnerPartA: "I want to be one",
        partnerPartB: "from Assistive.",
        start: "Start now",
        agree: "By creating my account I agree to the",
        haveAccount: "Already have an account?"
      },

      reset: {
        title: "authentication code",
        subtitle: "An email with the authentication code was sent to:",
        code: "Enter the 6-digit code",
        valid: "Validate",
        codeSpan: "Didn't receive the code?"
      },
      forgot: {
        title: "Forgot password?",
        subtitle: "Enter your registration email and we will send you instructions to reset your password.",
        sendInfo: "Send information",
        backLogin: "Back to login",
        sentTitle: "Instructions sent!",
        sentSubtitle: "We have just sent you an email with instructions for resetting your password."
      },
      installation: {
        instructions: "Instructions",
        instructionsHelp: `
            Here is the code for installing the Assistive widget.
            Now just copy and insert the installation code
            immediately before the closing body tag on your website.
            If you want to customize our widget to look like
            your brand, select the option "custom installation"`,
        installationCustom: "Custom installation",
        copy: "Copy code",
        sendInstructions: "Forward instructions",
        retract: "Retract",
        expand: "Expand",
        viewCode: "View installation code",
        modalSendEmails: {
          title: 'Send instructions by email',
          description: 'To include more than one email address, simply separate them with a comma.',
          emailLabel: 'Email',
          emailPlaceholder: 'email address.',
          invalidEmails: 'one or more emails are invalid!',
          sendButton: 'Send instructions',
          successToast: 'Code sent to emails successfully'
        }
      },
      sites: {
        mySites: "My websites",
        noSite: "You haven't registered any website yet.",
        addNow: "Add now",
        plan: "Plan",
        domain: "Domains",
        all: "all",
        inactive: "inactive",
        actives: "active",
        addSite: "Add Website",
        updatedSite: "Updating website",
        code: "View installation code",
        search: "Search",
        
        planStatus: {
          trial: {
            daysRemaining: '{{days}} days remaining to end your free trial',
            hoursRemaining: '{{hours}} hours remaining to end your free trial',
            expired: 'Your trial period has ended, activate your license to continue using'
          },
          active: {
            renewal: 'Automatic renewal on {{date}}.',
            renewalDays: 'Automatic renewal in {{days}} days.'
          },
          expired: 'Your plan expired on {{date}}',
          grace: 'Your plan is in grace period and will be deactivated on {{date}}'
        },
        planDescription: {
          free: 'For companies with up to 10 employees, subject to analysis.',
          essential: 'For companies with sites with low access volume. Only 1 (one) domain.',
          advanced: 'Plan up to 10,000 page views. For companies with intermediate access volume and more than one domain. Up to 2 (two) domains.',
          enterprise: 'Plan with unlimited page views. For companies with high access volume that require managed and personalized services.'
        },
        actions: {
          activateLicense: 'Activate license',
          promotionalCode: 'Promotional code',
          updatePlan: 'Update plan'
        },
        trialLabel: 'TRIAL',
        modalCode: {
          description: 'Copy the code below and deploy it to your domain',
          copyButton: 'Copy Code'
        }
      },
      dashboard: {
        header: {
          title: 'Dashboard'
        },
        periods: {
          lastMonth: 'Last month',
          threeMonths: '3 months',
          twelveMonths: '12 months'
        },
        months: {
          jan: 'Jan',
          fev: 'Feb',
          mar: 'Mar',
          abr: 'Apr',
          mai: 'May',
          jun: 'Jun',
          jul: 'Jul',
          ago: 'Aug',
          set: 'Sep',
          out: 'Oct',
          nov: 'Nov',
          dez: 'Dec'
        },
        globalAlert: {
          title: 'No usage data yet:',
          description: 'We are collecting usage information to update the dashboard.'
        },
        topMetrics: {
          pageViews: {
            title: 'Page Views',
            subtitle: 'Total page views'
          },
          pluginOpens: {
            title: 'Plugin Opens',
            subtitle: 'Total times the plugin was opened'
          },
          totalEvents: {
            title: 'Total Events',
            subtitle: 'Total interactions with the plugin'
          },
          emptyDash: '--'
        },
        usageOverTime: {
          title: 'Usage over time',
          seriesName: 'Events',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'Start using your plugin to see performance',
            subtitle: 'Here you will understand plugin usage over the months.'
          }
        },
        insights: {
          title: 'Trends and Insights',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'Wait for data collection',
            subtitle: 'We are collecting information to display trends and Insights.'
          },
          dynamic: {
            topFeature: {
              prefix: 'The tool ',
              middle: ' was the most used, accumulating ',
              suffix: ' events in the period.'
            },
            peakUsage: {
              dayPrefix: 'The day ',
              monthPrefix: 'The month of ',
              middle: ' recorded the highest usage volume, reaching ',
              suffix: ' events.'
            },
            topProfile: {
              prefix: 'The navigation profile ',
              middle: ' led in number of activations, being triggered ',
              suffix: ' times.'
            }
          }
        },
        resourcesRanking: {
          title: 'Most used resources',
          error: {
            message: 'Failed to load information',
            retry: 'Try Again'
          },
          empty: {
            title: 'No usage data yet',
            subtitle: 'We are collecting information to display this data.'
          },
          footer: 'Monthly result of all resources used.',
          events: 'events'
        },
        profiles: {
          title: 'Distribution of used profiles',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            title: 'No usage data yet',
            subtitle: 'We are collecting information to display this data.'
          },
          footerLinkText: 'Learn how accessibility profiles work',
          iconAlt: 'Icon',
          arrowAlt: 'Arrow',
          tooltip: {
            eventsLabel: 'events'
          }
        },
        detailedUsage: {
          title: 'Detailed resource usage',
          filter: {
            all: 'All',
            categories: {
              content: 'Content',
              navigation: 'Navigation',
              colorAndScreen: 'Color and Screen'
            }
          },
          searchPlaceholder: 'Search',
          searchAlt: 'Search',
          subtitleAll: 'All',
          subtitleFiltered: 'Filtered Results',
          error: {
            message: 'Unable to load data.',
            retry: 'Try Again'
          },
          empty: {
            noData: 'No usage data available at the moment.',
            noResults: 'No resource found for this search.'
          },
          events: 'events'
        }
      },
      accountSettings: {
        title: 'Account settings',
        tabs: {
          account: 'Account',
          security: 'Security',
          billing: 'Billing & Plan'
        },
        accountTab: {
          sectionTitle: 'Account type',
          saveButton: 'Save changes',
          cancelButton: 'Cancel'
        },
        deleteAccount: {
          title: 'Delete account',
          warningStrong: 'Are you sure you want to delete this account?',
          warningText: 'Once you delete your account, there is no going back. Please be certain.',
          confirmLabel: 'Confirm deletion of my account',
          button: 'Delete account'
        },
        formBilling: {
          taxpayerTypeCorporate: 'Legal entity',
          taxpayerTypePersonal: 'Individual',
          companyDataTitle: 'Company details',
          personalDataTitle: 'Personal details',
          cpfLabel: 'Identification document (CPF)',
          cpfInvalid: 'Invalid CPF',
          cnpjLabel: 'Identification document (CNPJ)',
          cnpjInvalid: 'Invalid CNPJ',
          simplesLabel: 'Enrolled in Simples Nacional?',
          simplesYes: 'Yes',
          simplesNo: 'No',
          corporateName: 'Corporate name',
          fullName: 'Full name',
          fantasyName: 'Trade name',
          required: 'Required field',
          financialContact: 'Financial contact',
          responsibleName: 'Responsible name',
          responsibleNamePlaceholder: 'Responsible name',
          financialEmail: 'Email (that will receive the invoice)',
          emailInvalid: 'The email provided is invalid',
          phone: 'Phone',
          phoneInvalid: 'The phone number provided is invalid!',
          address: 'Address',
          zipCode: 'ZIP code',
          zipCodeInvalid: 'Invalid ZIP code',
          number: 'Number',
          complement: 'Complement',
          neighborhood: 'Neighborhood',
          state: 'State',
          city: 'City',
          toast: {
            loading: 'Saving request',
            success: 'Saved.',
            error: 'Error saving request, please try again later'
          }
        },
        limitePlan: {
          title: 'Plan limits',
          availableDomains: 'Available domains',
          pageviewsPerMonth: 'Pageviews per month'
        },
        invoiceTable: {
          title: 'Invoice history',
          headers: {
            date: 'Date',
            invoiceNumber: 'Invoice number',
            plan: 'Plan',
            amount: 'Amount',
            status: 'Status'
          },
          statuses: {
            open: 'Open',
            paid: 'Paid'
          },
          actions: {
            download: 'Download invoice',
            view: 'View invoice'
          },
          empty: 'You have no charges.'
        }
      },
      perfil: {
        title: 'Profile',
        userInfo: {
          title: 'User information',
          subtitle: 'Update your user information',
          fullName: 'Full name',
          nickname: 'Nickname',
          email: 'Email address',
          phone: 'Phone',
          required: 'This is a required field',
          saveButton: 'Save changes',
          changePasswordButton: 'Change password',
          toast: {
            loading: 'Updating information',
            success: 'Information updated',
            error: 'Error updating information'
          }
        },
        changePassword: {
          title: 'Change password',
          subtitle: 'The password must contain at least 8 characters.',
          oldPassword: 'Old password',
          newPassword: 'New password',
          required: 'This is a required field',
          minLength: 'The password must be at least 8 characters long.',
          button: 'Change password',
          toast: {
            error: 'Incorrect password',
            success: 'Changed successfully'
          }
        }
      },
      features: {
        tags: {
          conteudo: 'Content',
          navegacao: 'Navigation',
          corTela: 'Color and Screen',
          perfil: 'Profile'
        },
        init: 'Page views',
        toolbarT: 'Plugin opens',
        textsize1T: 'Larger Text 125%',
        textsize2T: 'Larger Text 140%',
        textsize3T: 'Larger Text 170%',
        textsize4T: 'Larger Text 200%',
        align_centerT: 'Center Alignment',
        align_justifyT: 'Justified Alignment',
        align_leftT: 'Left Alignment',
        align_rightT: 'Right Alignment',
        font_dyslexicT: 'Dyslexic Font',
        font_sansserifT: 'Sans Serif Font (Reading)',
        font_serifT: 'Serif Font',
        linespacing1T: 'Line Spacing 120%',
        linespacing2T: 'Line Spacing 140%',
        linespacing3T: 'Line Spacing 160%',
        charspacing1T: 'Letter Spacing 105%',
        charspacing2T: 'Letter Spacing 110%',
        charspacing3T: 'Letter Spacing 120%',
        imageT: 'No images',
        spkOpen: 'Site Reader',
        tooltipsT: 'Show Descriptions',
        imgdescT: 'Image Descriptions',
        soundT: 'No Sound',
        vlibrasT: 'Libras',
        smartcontrast_defaultT: 'Minimum Text Contrast',
        smartcontrast_highT: 'Medium Text Contrast',
        smartcontrast_maxT: 'Maximum Text Contrast',
        contrast1T: 'Page Contrast 125%',
        contrast2T: 'Page Contrast 150%',
        contrast3T: 'Page Contrast 175%',
        contrast4T: 'Page Contrast 200%',
        contrast5T: 'Page Contrast 300%',
        saturation_dessaturateT: 'Faded Colors',
        saturation_highT: 'Intense Colors',
        saturation_lowT: 'Grayscale',
        colors_invertT: 'Invert Colors',
        colors_shift60T: 'Colors (Rotates 60°)',
        colors_shift120T: 'Colors (Rotates 120°)',
        colors_shift240T: 'Colors (Rotates 240°)',
        magnifyingT: 'Magnifying Glass',
        structclick: 'Page Structure',
        cursor_blackT: 'Black Cursor',
        cursor_blueT: 'Blue Cursor',
        cursor_redT: 'Red Cursor',
        cursor_whiteT: 'White Cursor',
        guideT: 'Reading Guide',
        rulerT: 'Reading Ruler',
        animationT: 'Stop Animations',
        highlight_allT: 'Highlight All Elements',
        highlight_btnT: 'Highlight Buttons',
        highlight_linkT: 'Highlight Links',
        highlight_titleT: 'Highlight Titles',
        focusT: 'Keyboard Focus Highlight',
        prof_p60_T: 'Navigation 60+',
        prof_seizures_T: 'Epilepsy Navigation',
        prof_vision_T: 'Low Vision Navigation',
        prof_adhd_T: 'ADHD Navigation',
        prof_dyslexic_T: 'Dyslexia Navigation',
        prof_cognitive_T: 'Cognitive assistance navigation',
        prof_motor_T: 'Keyboard navigation',
        prof_blind_T: 'Screen reader navigation (Blind)'
      }
    }
  }
